import React, { useEffect, useState } from 'react';
import { MAIN_API_URL } from '../../configuration';
import { activateImpersonationSession, extractImpersonationToken } from './impersonationSession';

const pageStyle = {
  minHeight: '100vh',
  display: 'grid',
  placeItems: 'center',
  padding: '24px',
  background: 'var(--background, #f7faf8)',
  color: 'var(--text-primary, #17211c)',
};

const cardStyle = {
  maxWidth: '440px',
  padding: '28px',
  border: '1px solid #cfe5d8',
  borderRadius: '16px',
  background: '#fff',
  textAlign: 'center',
  boxShadow: '0 16px 48px rgba(22, 70, 43, 0.10)',
};

async function fetchStoreFromApi(token) {
  const response = await fetch(`${MAIN_API_URL}/stores`, {
    headers: { 'x-token': token },
  });
  if (!response.ok) throw new Error('El acceso de soporte es inválido o venció');
  return response.json();
}

function redirectTo(path) {
  window.location.replace(path);
}

export default function SupportImpersonationEntry({
  hash = window.location.hash,
  fetchStore = fetchStoreFromApi,
  onSuccess = redirectTo,
}) {
  const [error, setError] = useState('');

  useEffect(() => {
    const token = extractImpersonationToken(hash);
    window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
    if (!token) {
      setError('Falta el token de acceso de soporte');
      return undefined;
    }

    let active = true;
    (async () => {
      try {
        const store = await fetchStore(token);
        if (!active) return;
        activateImpersonationSession({ token, store });
        onSuccess('/home');
      } catch (requestError) {
        if (active) setError(requestError.message || 'No se pudo abrir la tienda');
      }
    })();

    return () => { active = false; };
  }, [hash, fetchStore, onSuccess]);

  return (
    <main style={pageStyle}>
      <section style={cardStyle} aria-live="polite">
        <h1>{error ? 'No se pudo entrar' : 'Validando acceso de soporte'}</h1>
        <p>{error || 'Abriendo la tienda en modo de solo lectura…'}</p>
      </section>
    </main>
  );
}
